import { useEffect, useRef, useState } from "react";

export const useCustomCursor = () => {
  const cursorRef = useRef(null);
  const ringRef = useRef(null);
  const animationFrameRef = useRef(null);

  const mouse = useRef({ x: 0, y: 0 });
  const ring = useRef({ x: 0, y: 0 });

  const [isHoveringInteractive, setIsHoveringInteractive] = useState(false);

  useEffect(() => {
    const cursor = cursorRef.current;
    const cursorRing = ringRef.current;

    if (!cursor || !cursorRing) return;

    const handleMouseMove = (event) => {
      mouse.current.x = event.clientX;
      mouse.current.y = event.clientY;

      cursor.style.left = `${event.clientX}px`;
      cursor.style.top = `${event.clientY}px`;
    };

    const animateRing = () => {
      ring.current.x += (mouse.current.x - ring.current.x) * 0.12;
      ring.current.y += (mouse.current.y - ring.current.y) * 0.12;

      cursorRing.style.left = `${ring.current.x}px`;
      cursorRing.style.top = `${ring.current.y}px`;

      animationFrameRef.current = requestAnimationFrame(animateRing);
    };

    const handleMouseOver = (event) => {
      if (event.target.closest("a, button")) {
        setIsHoveringInteractive(true);
      }
    };

    const handleMouseOut = (event) => {
      if (event.target.closest("a, button")) {
        setIsHoveringInteractive(false);
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);

    animateRing();

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", handleMouseOut);

      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return {
    cursorRef,
    ringRef,
    isHoveringInteractive,
  };
};
